module.exports = __webpack_public_path__ + "img/category_10.ae238b21.png";